import { Component, Input } from '@angular/core';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-commercial-invoice',
  templateUrl: './commercial-invoice.component.html',
  styleUrls: ['./commercial-invoice.component.scss']
})
export class CommercialInvoiceComponent {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';


  ngOnChanges(): void {
    console.log('Invoices changed:', this.invoices);

    this.invoices.forEach(invoice => {
      if (!invoice.vehicles) {
        invoice.vehicles = [invoice.vehicle];
      }
    });
    
  }

  constructor() { }

  formatDate(dateString: string | null): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '-';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // Get chassis number formatted
  getChassisNumber(invoice: Invoice): string {
    return invoice.vehicle?.chassis_no || '-';
  }

  // Get stock number
  getStockNumber(invoice: Invoice): string {
    return invoice.vehicle?.car_no || '-';
  }

  // Get vehicle description for goods section
  getVehicleDescription(invoice: Invoice): string {
    const make = invoice.vehicle?.make || '';
    const model = invoice.vehicle?.model || '';
    const year = invoice.vehicle?.year || '';
    return `${year} ${make} ${model}`.trim();
  }

  // Get current date formatted
  getCurrentDate(): string {
    return this.formatDate(new Date().toISOString());
  }

  // Get HS Code
  getHSCode(invoice: Invoice): string {
    return invoice.vehicle?.hs_code || '8703';
  }

  // Calculate total for static vehicles
  getTotalAmount(): string {
    const total = this.invoices.reduce((sum, invoice) => {
      const price = invoice.invoice_amount;
      return sum + price;
    }, 0);
    return `$ ${total.toLocaleString('en-US')}`;
  }

  // Get total quantity
  getTotalQuantity(): number {
    return this.invoices[0]?.vehicles?.length || 0;
  }

}
